<ng-container>
  <c-container
    [fluid]="true"
    class="border-0 app-topbar app-topbar-inner min-w-0 app-topbar-inner--imaginus"
    [class.app-topbar-inner--imaginus-titled]="!!imaginusHeaderTitle"
  >
    <div class="app-topbar-shell-controls d-flex align-items-center flex-shrink-0 min-w-0 gap-1">
      <app-nav-back *ngIf="showHeaderNavBack" class="me-1" [compact]="true"></app-nav-back>
      <button
        type="button"
        class="btn btn-link team-header-menu-btn team-sidebar-toggle p-0"
        (click)="onHeaderSidebarToggle()"
        [attr.aria-label]="headerSidebarToggleLabel"
        [attr.title]="headerSidebarToggleLabel"
      >
        <svg cIcon name="cilMenu" size="lg" class="team-sidebar-icon"></svg>
      </button>
    </div>

    <div *ngIf="showImaginusToolbar && imaginusHeaderTitle" class="team-header-imaginus">
      <div
        class="team-header-imaginus__pill"
        [class.team-header-imaginus__pill--has-actions]="activeSessionActions.length"
      >
        <div class="team-header-imaginus__pill-body min-w-0">
          <span class="team-header-imaginus__title" [attr.title]="imaginusHeaderTitle || null">{{ imaginusHeaderTitle }}</span>
          <span
            *ngIf="activeSessionSubtitle"
            class="team-header-imaginus__subtitle"
            [attr.title]="activeSessionSubtitle"
          >{{ activeSessionSubtitle }}</span>
        </div>
        <ng-container *ngIf="activeSessionActions.length">
          <span class="team-header-imaginus__pill-divider" aria-hidden="true"></span>
          <button
            *ngFor="let action of activeSessionActions; trackBy: trackByHeaderActionId"
            type="button"
            class="team-header-imaginus__pill-action"
            [attr.aria-label]="action.ariaLabel || action.label"
            [attr.title]="action.title || action.label"
            (click)="onHeaderActionClick(action, $event)"
          >
            <svg *ngIf="action.iconPath" viewBox="0 0 24 24" aria-hidden="true">
              <path
                [attr.d]="action.iconPath"
                fill="none"
                stroke="currentColor"
                stroke-width="1.7"
                stroke-linejoin="round"
                stroke-linecap="round"
              />
            </svg>
          </button>
        </ng-container>
      </div>
    </div>

    <c-header-nav class="d-flex align-items-center ms-auto flex-shrink-0 team-header-user-nav">
      <app-help-article-link
        class="me-2"
        [articleId]="help.QUICK_START_RECOMMENDED_FLOW"
        [ariaLabel]="'header.user_guide' | translate"
        [title]="'header.user_guide' | translate"
      />
      <c-dropdown
        variant="nav-item"
        [(visible)]="userMenuOpen"
        [popperOptions]="userMenuPopperOptions"
        class="team-header-user-dropdown"
      >
        <button
          type="button"
          [caret]="false"
          cDropdownToggle
          class="py-0 border-0 bg-transparent position-relative team-header-user-toggle"
          [attr.aria-label]="'header.open_user_menu' | translate"
          aria-haspopup="true"
          [attr.aria-expanded]="userMenuOpen"
        >
      <img
        [src]="previewImage || profile_picture || defaultAvatarUrl"
        class="rounded-circle border border-2 border-white shadow-sm"
        width="45"
        height="45"
        style="object-fit: cover; object-position: center;"
        loading="eager"
        alt="User avatar"
        (error)="onAvatarImageError()"
      />
      <span
        *ngIf="hasUnreadMail"
        class="position-absolute top-0 start-100 translate-middle team-header-unread-dot"
        aria-hidden="true"
      ></span>
    </button>

    <div cDropdownMenu class="user-menu-dropdown pt-0 border-0 shadow-lg">
         <div class="user-menu-dropdown__hero">
             <div class="position-relative d-inline-block mb-2">
               <img
                [src]="previewImage || profile_picture || defaultAvatarUrl"
                class="rounded-circle"
                width="80"
                height="80"
                style="object-fit: cover; object-position: center;"
                (error)="onAvatarImageError()"
              />
              <span class="position-absolute bottom-0 end-0 bg-success p-1 border border-2 border-white rounded-circle"></span>
            </div>
            <h5 class="fw-bold mb-0 text-dark">{{ user.firstname }} {{ user.lastname }}</h5>
            <div class="text-muted small mb-0">{{ user.email }}</div>
         </div>

      <div class="user-menu-dropdown__scroll">
        <div class="user-menu-dropdown__actions">
          <a cDropdownItem (click)="OpenMailbox()" class="d-flex align-items-center px-4 py-2 dropdown-link">
            <div class="icon-wrapper bg-light text-primary rounded-circle me-3 d-flex align-items-center justify-content-center" style="width: 36px; height: 36px;">
              <svg cIcon name="cilBell" size="md"></svg>
            </div>
            <div class="flex-grow-1 min-w-0">
              <span class="d-block fw-semibold">{{ 'header.notifications' | translate }}</span>
              <small *ngIf="hasUnreadMail" class="text-danger">{{ 'header.unread_notifications' | translate }}</small>
              <small *ngIf="!hasUnreadMail" class="text-muted">{{ 'header.no_new_notifications' | translate }}</small>
            </div>
            <span *ngIf="hasUnreadMail" class="team-header-menu-unread-badge">{{ 'header.unread_badge' | translate }}</span>
          </a>

          <a cDropdownItem [routerLink]="['/task-manager']" class="d-flex align-items-center px-4 py-2 dropdown-link">
            <div class="icon-wrapper bg-light text-warning rounded-circle me-3 d-flex align-items-center justify-content-center" style="width: 36px; height: 36px;">
              <svg cIcon name="cilCalendarCheck" size="md"></svg>
            </div>
            <span class="fw-semibold">{{ 'header.tasks' | translate }}</span>
          </a>

          <a cDropdownItem routerLink="/help" target="_blank" rel="noopener" class="d-flex align-items-center px-4 py-2 dropdown-link">
            <div class="icon-wrapper bg-light text-info rounded-circle me-3 d-flex align-items-center justify-content-center" style="width: 36px; height: 36px;">
              <svg cIcon name="cilDescription" size="md"></svg>
            </div>
            <span class="fw-semibold">{{ 'header.user_guide' | translate }}</span>
          </a>

          <a cDropdownItem [routerLink]="['/settings']" class="d-flex align-items-center px-4 py-2 dropdown-link">
            <div class="icon-wrapper bg-light text-secondary rounded-circle me-3 d-flex align-items-center justify-content-center" style="width: 36px; height: 36px;">
              <svg cIcon name="cilSettings" size="md"></svg>
            </div>
            <span class="fw-semibold">{{ 'header.system_settings' | translate }}</span>
          </a>
        </div>
      </div>

      <div class="border-top p-2 text-center bg-transparent">
        <button cDropdownItem (click)="onlogout()" class="btn btn-light btn-logout w-100 py-2 rounded border-0">
          <svg cIcon name="cilAccountLogout" class="me-2"></svg>
          {{ 'common.logout' | translate }}
        </button>
      </div>
    </div>
  </c-dropdown>
    </c-header-nav>
  </c-container>

</ng-container>
